import type { MenuDefinition } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { RibbonFlyoutAnchorProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon';
import { computedFn } from 'mobx-utils/lib/computedFn';
import loc from 'owa-localize';
import GroupStrings from 'owa-locstrings/lib/strings/ribbon_mail_groups.locstring.json';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { MailRibbonGroupId } from 'owa-ribbon-ids';
import { createMailAppFlyoutAnchor } from '../../../util/createMailRibbonButton';
import ClipboardPaste from 'owa-fluent-icons-svg/lib/icons/ClipboardPasteRegular';
import AlignCenter from 'owa-fluent-icons-svg/lib/icons/TextAlignCenterRegular';
import FontColor from 'owa-fluent-icons-svg/lib/icons/TextColorRegular';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';

const emptyMenuDefinition: MenuDefinition = {
    sections: [],
};

export const getMLRFormatTabCommonGroupFlyout = computedFn(
    (
        group: RibbonGroupId,
        popoutComposeViewState?: ComposeViewState
    ): RibbonFlyoutAnchorProps | undefined => {
        const isPopout: boolean = popoutComposeViewState != undefined;

        switch (group) {
            case MailRibbonGroupId.Group_Clipboard_Format:
                const clipBoardGroupId: string = getComposeRibbonId(
                    group,
                    popoutComposeViewState
                ).toString();
                return createMailAppFlyoutAnchor(
                    clipBoardGroupId,
                    loc(GroupStrings.clipboard_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    ClipboardPaste
                );

            case MailRibbonGroupId.Group_BasicText:
                const textGroupId: string = getComposeRibbonId(
                    group,
                    popoutComposeViewState
                ).toString();
                return createMailAppFlyoutAnchor(
                    textGroupId,
                    loc(GroupStrings.basicText_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    FontColor
                );

            case MailRibbonGroupId.Group_Paragraph:
                const paragraphGroupId: string = getComposeRibbonId(
                    group,
                    popoutComposeViewState
                ).toString();
                return createMailAppFlyoutAnchor(
                    paragraphGroupId,
                    loc(GroupStrings.paragraph_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    AlignCenter
                );

            default:
                return undefined;
        }
    }
);
